import { NgModule } from '@angular/core';
import { environment } from 'environments/environment';
import { KI_API_BASE_URL } from './iop-katalog-institucija-api-reference';
import { API_BASE_URL } from './iop-metaregistar-api-reference';
import { UK_API_BASE_URL } from './uk-api-reference';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    {
      provide: API_BASE_URL,
      useValue: environment.apiUrl
    },
    {
      provide: KI_API_BASE_URL,
      useValue: environment.kiApiUrl
    },
    {
      provide: UK_API_BASE_URL,
      useValue: environment.usersApiUrl
    }
  ]
})
export class ApiModule { }